// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"styles_checkboxWrapper__1_q4c","checkBox":"styles_checkBox__14xU2"};